'use strict';
var $ = require('../internals/export');
var $values = require('../internals/object-to-array').values;

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/modules/es.object.values.js
// module id = 424
// module chunks = 0